// src/routes/PublicRoutes.tsx
import { Suspense, lazy } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

// Lazy load public pages
const PricingPage = lazy(() => import('../pages/Signup/PricingPage'));

// Loading component for public pages
const PublicPageSkeleton = () => (
  <div className="min-h-screen bg-gradient-to-br from-background to-muted/20">
    <div className="container mx-auto px-4 py-16">
      <div className="text-center mb-16">
        <Skeleton className="h-12 w-96 mx-auto mb-4" />
        <Skeleton className="h-6 w-128 mx-auto" />
      </div>
      
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-card border rounded-lg p-6">
            <Skeleton className="h-12 w-12 rounded-full mx-auto mb-4" />
            <Skeleton className="h-6 w-32 mx-auto mb-4" />
            <Skeleton className="h-8 w-24 mx-auto mb-2" />
            <Skeleton className="h-4 w-40 mx-auto mb-6" />
            <div className="space-y-3 mb-6">
              {[1, 2, 3, 4].map((j) => (
                <div key={j} className="flex items-center gap-3">
                  <Skeleton className="h-4 w-4 rounded" />
                  <Skeleton className="h-4 flex-1" />
                </div>
              ))}
            </div>
            <Skeleton className="h-10 w-full" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

const PublicRoutes = [
  {
    path: '/pricing',
    element: (
      <Suspense fallback={<PublicPageSkeleton />}>
        <PricingPage />
      </Suspense>
    )
  }
];

export default PublicRoutes;